export type GetImageMinimapViewportParams = {
  containerHeight: number;
  containerWidth: number;
  fitHeight: number;
  fitWidth: number;
  posX: number;
  posY: number;
  zoom: number;
};

export type ImageMinimapViewport = {
  height: number;
  left: number;
  top: number;
  width: number;
};

const clampToUnitInterval = (value: number) => Math.min(1, Math.max(0, value));

export const getImageMinimapViewport = ({
  containerHeight,
  containerWidth,
  fitHeight,
  fitWidth,
  posX,
  posY,
  zoom,
}: GetImageMinimapViewportParams): ImageMinimapViewport | null => {
  const geometry = [containerHeight, containerWidth, fitHeight, fitWidth, posX, posY, zoom];

  if (
    geometry.some((value) => !Number.isFinite(value)) ||
    containerHeight <= 0 ||
    containerWidth <= 0 ||
    fitHeight <= 0 ||
    fitWidth <= 0 ||
    zoom <= 0
  ) {
    return null;
  }

  const drawnWidth = fitWidth * zoom;
  const drawnHeight = fitHeight * zoom;
  const imageLeft = containerWidth / 2 + posX - drawnWidth / 2;
  const imageTop = containerHeight / 2 + posY - drawnHeight / 2;

  if (!Number.isFinite(drawnWidth) || !Number.isFinite(drawnHeight)) {
    return null;
  }

  const left = clampToUnitInterval(-imageLeft / drawnWidth);
  const top = clampToUnitInterval(-imageTop / drawnHeight);
  const right = clampToUnitInterval((containerWidth - imageLeft) / drawnWidth);
  const bottom = clampToUnitInterval((containerHeight - imageTop) / drawnHeight);

  return {
    height: Math.max(0, bottom - top),
    left,
    top,
    width: Math.max(0, right - left),
  };
};
